import { CallStatus } from '@shared/services/apiService/apiService';
import { ConversationActorsType } from '@shared/services/conversationApiService/apiService';

export const CampaignCallStatus: Record<Uppercase<CallStatus>, CallStatus> = {
  PENDING: 'pending',
  SCHEDULED: 'scheduled',
  INITIALIZING: 'initializing',
  QUEUED: 'queued',
  RINGING: 'ringing',
  'IN-PROGRESS': 'in-progress',
  ENDED: 'ended',
};

export const CallActors: Record<Uppercase<ConversationActorsType>, ConversationActorsType> = {
  AGENT: 'agent',
  CUSTOMER: 'customer',
  NOICE: 'noice',
  LISTENER: 'listener',
  MRCP: 'mrcp',
};
